<template>
  <div class="cul">
    <div class="top">
      <img class="line" src="../assets/index/line.png" alt="" />
      <div class="title">企业文化</div>
    </div>

    <!-- 上大图 -->
    <!-- :style="active == index ? item.bg : ''" -->
    <div
      class="pic"
      :style="{
        'background-image': `url(${bannerimg})`,
      }"
    >
      <div class="yj">
        <div class="icon">
          <img :src="`${icon}`" alt="" />
          <span style="color: #ffffff">{{ subtitle }}</span>
        </div>
        <div>
          <div class="title" style="color: #ffffff">
            {{ title }}
          </div>
          <div class="desc" v-html="desc" style="color: #ffffff"></div>
        </div>
      </div>
    </div>

    <div class="ser">
      <div class="contWrap" v-for="(item, index) in bottomlist" :key="index">
        <div class="title">
          <div class="icon">
            <img src="../assets/culture/icon.png" alt="" />
          </div>
          <div class="name">{{ item.title }}</div>
        </div>
        <div class="content">
          {{ item.desc }}
        </div>
        <img class="fw" :src="item.image" alt="" />
      </div>
    </div>

    <div class="xj">
      <div class="contWrap bottom-list">
        <div class="list" v-for="(item, index) in wenzilist" :key="index">
          <!-- 循环这里 -->
          <div class="listTitle">{{ item.title }}</div>
          <div class="desc">
            {{ item.desc }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { aboutCulture } from "../api/request";
export default {
  name: "Culture",
  data() {
    return {
      active: 0,
      // list: [
      //   {
      //     id: 0,
      //     name: "文化",
      //     bg: {
      //       backgroundImage:
      //         "url(" + require("../assets/culture/wh-bg.png") + ")",
      //       backgroundSize: "cover",
      //       backgroundPosition: "center center",
      //       backgroundCover: "cover",
      //     },
      //     img: require("../assets/culture/wh-bg.png"),
      //     icon: require("../assets/culture/wh-g.png"),
      //     activeIcon: require("../assets/culture/sm-w.png"),
      //     title: "阁韵“家”文化：为地球大家、服务真到家、为阁韵小家。",
      //     desc: "为地球大家：阁韵采用节能环保可再生材料，以绿色、低碳、节能、环保为己任，推广绿色门窗，节约社会资源，倡导低碳生活，是阁韵要承担的首要社会责任。\n",
      //   },
      // ],
      bottomlist: [],
      icon: null,
      bannerimg: null,
      wenzilist: [],
      title: "",
      desc: "",
      subtitle: "",
    };
  },
  methods: {
    handleMouse(index) {
      this.active = index;
    },
  },
  mounted() {
    aboutCulture().then((res) => {
      if (res.data.code == 1) {
        console.log(res.data.data);
        this.title = res.data.data.title;
        this.subtitle = res.data.data.subtitle;
        this.desc = res.data.data.desc;
        this.icon = res.data.data.icon;
        this.bannerimg = res.data.data.bg_image;
        this.bottomlist = res.data.data.list;
        this.wenzilist = res.data.data.welfare;
      }
    });
  },
};
</script>

<style scoped lang="less">
.cul {
  font-family: 微软雅黑, MicrosoftYaHei;
  .top {
    text-align: left;
    margin-left: 320px;
    background: #ffffff;
    width: 100%;
    padding: 59px 0;
    .line {
      width: 90px;
      height: 8px;
    }
    .title {
      font-size: 42px;
      font-family: MicrosoftYaHei;
      font-weight: bold;
      color: #004c31;
      margin-top: 24px;
    }
  }
  .pic {
    background-size: "cover";
    background-position: "center center";
    width: 100%;
    height: 351px;
    .yj {
      display: flex;
      align-items: flex-start;
      .icon {
        margin: 86px 180px 0 352px;
        width: 105px;
        height: 105px;
        color: #6c7a77;
        img {
          width: 105px;
          height: 105px;
        }
      }
      .title {
        margin-top: 86px;
        text-align: justify;
        font-size: 24px;
        font-family: 微软雅黑, MicrosoftYaHei;
        font-weight: 400;
        color: #004c31;
        line-height: 42px;
      }
      .desc {
        margin-top: 32px;
        text-align: justify;
        width: 960px;
        font-size: 20px;
        font-family: 微软雅黑, MicrosoftYaHei;
        font-weight: 400;
        color: #6c7a77;
        line-height: 36px;
      }
    }
  }
  .ser {
    width: 100%;
    background: #f2f2f2;
    .contWrap {
      padding: 100px 0;
      width: 1280px;
      margin: 0 auto;
      .title {
        margin-left: 320px;
        padding-bottom: 44px;
        border-bottom: 1px dotted #ccc;
        width: 960px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        .icon {
          margin-right: 17px;
          width: 43px;
          height: 43px;
          img {
            width: 43px;
            height: 43px;
          }
        }
        .name {
          width: 960px;
          font-size: 20px;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          text-align: justify;
          color: #6c7a77;
          line-height: 36px;
        }
      }
      .content {
        margin-left: 320px;
        margin-top: 50px;
        width: 960px;
        font-size: 20px;
        font-weight: 400;
        color: #6c7a77;
        line-height: 36px;
        text-align: justify;
      }
      .fw {
        width: 1280px;
        height: auto;
        margin-top: 50px;
      }
    }
  }
  .xj {
    width: 100%;
    .contWrap {
      padding: 100px 0;
      width: 1280px;
      margin: 0 auto;
      .title {
        margin-left: 320px;
        padding-bottom: 44px;
        border-bottom: 1px dotted #ccc;
        width: 960px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        .icon {
          margin-right: 17px;
          width: 43px;
          height: 43px;
          img {
            width: 43px;
            height: 43px;
          }
        }
        .name {
          width: 960px;
          font-size: 20px;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          text-align: justify;
          color: #6c7a77;
          line-height: 36px;
        }
      }
      .content {
        margin-left: 320px;
        margin-top: 50px;
        width: 960px;
        font-size: 20px;
        font-weight: 400;
        color: #6c7a77;
        line-height: 36px;
        text-align: justify;
      }
      .fw {
        width: 1280px;
        height: auto;
        margin-top: 50px;
      }
      .list {
        margin-left: 320px;
        width: 960px;
        text-align: left;
        .listTitle {
          margin-top: 32px;
          font-size: 24px;
          font-weight: bold;
          color: #004c31;
        }
        .desc {
          width: 960px;
          margin-top: 32px;
          font-size: 20px;
          font-weight: 400;
          color: #6c7a77;
        }
      }
      .list:last-child {
        margin-bottom: 100px;
      }
    }
    .bottom-list {
      padding: 0;
    }
  }
}
@media screen and (max-width: 450px) {
  .cul {
    font-family: 微软雅黑, MicrosoftYaHei;
    .top {
      text-align: left;
      margin-left: 320px;
      background: #ffffff;
      width: unset;
      padding: 59px 0;
      .line {
        width: 90 * 2px;
        height: 8 * 2px;
      }
      .title {
        font-size: 42 * 2px;
        font-family: MicrosoftYaHei;
        font-weight: bold;
        color: #004c31;
        margin-top: 24px;
      }
    }
    .pic {
      width: 100%;
      height: 351 * 2px;
      .yj {
        display: flex;
        align-items: flex-start;
        .icon {
          margin: 43px 90px 0 176px;
          width: 105 * 2px;
          height: 105 * 2px;
          color: #6c7a77;
          img {
            width: 105 * 2px;
            height: 105 * 2px;
          }
        }
        .title {
          margin-top: 86px;
          text-align: justify;
          font-size: 24 * 2px;
          font-family: 微软雅黑, MicrosoftYaHei;
          font-weight: 400;
          color: #004c31;
          line-height: unset;
        }
        .desc {
          margin-top: 32 * 2px;
          text-align: justify;
          width: 1280px;
          font-size: 20 * 2px;
          font-family: 微软雅黑, MicrosoftYaHei;
          font-weight: 400;
          color: #6c7a77;
          line-height: unset;
        }
      }
    }
    .ser {
      width: 100%;
      background: #f2f2f2;
      .contWrap {
        padding: 100px 0;
        width: 1280px;
        margin: 0 auto;
        .title {
          margin: 0 auto;
          padding-bottom: 44px;
          border-bottom: 1px dotted #ccc;
          width: 960px;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          .icon {
            margin-right: 17px;
            width: 43 * 2px;
            height: 43 * 2px;
            img {
              width: 43 * 2px;
              height: 43 * 2px;
            }
          }
          .name {
            width: 960px;
            font-size: 20 * 2px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            text-align: justify;
            color: #6c7a77;
            line-height: unset;
          }
        }
        .content {
          margin: 50px auto 0;
          width: 960px;
          font-size: 20 * 2px;
          font-weight: 400;
          color: #6c7a77;
          line-height: unset;
          text-align: justify;
        }
        .fw {
          width: 1280px;
          height: auto;
          margin-top: 50px;
        }
      }
    }
    .xj {
      width: 100%;
      .contWrap {
        padding: 100px 0;
        width: 1280px;
        margin: 0 auto;
        .title {
          margin: 0 auto;
          padding-bottom: 44px;
          border-bottom: 1px dotted #ccc;
          width: 960px;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          .icon {
            margin-right: 17px;
            width: 43 * 2px;
            height: 43 * 2px;
            img {
              width: 43 * 2px;
              height: 43 * 2px;
            }
          }
          .name {
            width: 960px;
            font-size: 20 * 2px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            text-align: justify;
            color: #6c7a77;
            line-height: unset;
          }
        }
        .content {
          margin: 50px auto 0;
          width: 960px;
          font-size: 20 * 2px;
          font-weight: 400;
          color: #6c7a77;
          line-height: unset;
          text-align: justify;
        }
        .fw {
          width: 1280px;
          height: auto;
          margin-top: 50px;
        }
        .list {
          margin: 0 auto;
          width: 960px;
          text-align: left;
          .listTitle {
            margin-top: 32 * 2px;
            font-size: 24 * 2px;
            font-weight: bold;
            color: #004c31;
          }
          .desc {
            width: 960px;
            margin-top: 32 * 2px;
            font-size: 20 * 2px;
            font-weight: 400;
            color: #6c7a77;
          }
        }
      }
    }
  }
}
</style>
